import { StaffMember } from '@/shared/domain/StaffMember';
import { StaffMemberRepository } from '@/shared/domain/StaffMemberRepository';
import { UseCase } from '@/shared/application/UseCase';

export class GetStaffMembersUseCase implements UseCase<null, Array<StaffMember>> {

  private repository: StaffMemberRepository;

  public constructor (repository: StaffMemberRepository) {
    this.repository = repository;
  }

  public async run (): Promise<Array<StaffMember>> {
    return await this.repository.getStaffMembers();
  }

}
